<template>
  <div class="logos">
    <div class="column">
      <img class="logo" src='@/assets/images/KZ/label-bb1.png'/>
    </div>
    <div class="column">
      <img class="logo" src='@/assets/images/KZ/label-bb2.png'/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KzLogos',
};
</script>

<style scoped>
.logos {
  display: inline-flex;
}

.logo {
  max-height: 170px;
}

.column {
  margin: 0 22px;
  align-content: center;
  display: inline-grid;
}
</style>
